// extracted by mini-css-extract-plugin
export var orderSummary = "_ov-0";
export var showMoreLessButton = "_ov-1";